var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorWhiteCsps2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186.5 8.8",
    style: {
      enableBackground: "new 0 0 186.5 8.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#247D91;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000002351685639177952800000010945180776708945823_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.1,
    className: "st0",
    width: 185.9,
    height: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.5,8.8h-14.4V0.1h14.4V8.8z M157.8,8.8h-14.4V0.1h14.4V8.8z M129.1,8.8h-14.4V0.1h14.4V8.8z M100.4,8.8 H86V0.1h14.4V8.8z M71.7,8.8H57.3V0.1h14.4V8.8z M43,8.8H28.6V0.1H43V8.8z M14.3,8.8H-0.1V0.1h14.4V8.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorWhiteCsps2);
export default __webpack_public_path__ + "static/media/Hor-white-CSPS-2.3ce0792ba0d145d81c7a9e2d7f5863ee.svg";
export { ForwardRef as ReactComponent };